import { render, staticRenderFns } from "./CourseShowTabs.vue?vue&type=template&id=bb234e8e&scoped=true"
import script from "./CourseShowTabs.vue?vue&type=script&lang=js"
export * from "./CourseShowTabs.vue?vue&type=script&lang=js"
import style0 from "./CourseShowTabs.vue?vue&type=style&index=0&id=bb234e8e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb234e8e",
  null
  
)

export default component.exports